import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useState, useCallback, useRef } from 'react';
export const useModalPromise = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setOpened = _useState2[1];
  const promise = useRef({});
  const show = useCallback(async () => {
    setOpened(true);
    try {
      return await new _Promise((resolve, reject) => {
        _Object$assign(promise.current, {
          resolve,
          reject
        });
      });
    } finally {
      setOpened(false);
    }
  }, []);
  const resolve = useCallback(result => promise.current.resolve(result), [promise]);
  const reject = useCallback(error => promise.current.reject(error), [promise]);
  return [isOpened, show, resolve, reject];
};